import { APP_ASSET_BASEURL } from '~/helpers/constants'

export const PAGE_DATA = {
  validAge: [16, 120],

  lifeStage: [
    {
      label: 'Single',
      name: 'single',
      value: 'Single'
    },
    {
      label: 'Couple',
      name: 'couple',
      value: 'Couple'
    },
    {
      label: 'Family',
      name: 'family',
      value: 'Family'
    },
    {
      label: 'Single Parent Family',
      name: 'single-parent-family',
      value: 'Single Parent'
    }
  ],

  healthCover: [
    {
      label: 'Cheaper cover',
      value: 'Cheaper cover'
    },
    {
      label: 'Better hospital and/or extras cover',
      value: 'Better hospital and/or extras cover'
    },
    {
      label: 'My (or family\'s) specific health concern',
      value: 'My (or family\'s) specific health concern'
    },
    {
      label: 'Avoiding the Medicare Levy Surcharge (MLS)',
      value: 'Avoiding the Medicare Leavy Surcharge (MLS)'
    },
    {
      label: 'Planning on having a baby',
      value: 'Planning on having a baby'
    },
    {
      label: 'Change of circumstances',
      value: 'Change of circumstances'
    },
    {
      label: 'New arrival to Australia',
      value: 'New arrival to Australia'
    },
    {
      label: 'Health cover required as a condition of visa',
      value: 'Health cover required as a condition of visa'
    }
  ],

  incomes: {
    single: [
      {
        label: '$101,000 or less (Base tier)',
        desc: 'A 24.288% (Base tier) government rebate will be applied.',
        value: 'nil',
        tierLabel: 'Base Tier',
        rebate: 24.288,
        idSuffix: 'annualincome-nil',
        income: '$101,000 or less'
      },
      {
        label: '$101,001 - $118,000 (Tier 1)',
        desc: 'A 16.192% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.192,
        idSuffix: 'annualincome-low',
        income: '$101,001 - $118,000',
        tierLabel: 'Tier 1'
      },
      {
        label: '$118,001 - $158,000 (Tier 2)',
        desc: 'A 8.095% (Tier 2) government rebate will be applied.',
        value: 'medium',
        rebate: 8.095,
        idSuffix: 'annualincome-medium',
        income: '$118,001 - $158,000',
        tierLabel: 'Tier 2'
      },
      {
        label: '$158,001 or more (no rebate) (Tier 3)',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: '0.00',
        idSuffix: 'annualincome-high',
        income: '$158,001 or more',
        tierLabel: 'Tier 3'
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: '0.00',
        idSuffix: 'none',
        income: '$0',
        tierLabel: ''
      }
    ],
    couple: [
      {
        label: '$202,000 or less (Base tier)',
        desc: 'A 24.288% (Base tier) government rebate will be applied.',
        value: 'nil',
        rebate: 24.288,
        idSuffix: 'annualincome-nil',
        income: '$202,000 or less',
        tierLabel: 'Base Tier'
      },
      {
        label: '$202,001 - $236,000 (Tier 1)',
        desc: 'A 16.192% (Tier 1) government rebate will be applied.',
        value: 'low',
        rebate: 16.192,
        idSuffix: 'annualincome-low',
        income: '$202,001 - $236,000',
        tierLabel: 'Tier 1'
      },
      {
        label: '$236,001 - $316,000 (Tier 2)',
        desc: 'A 8.095% (Tier 2) government rebate will be applied.',
        value: 'medium',
        tierLabel: 'Tier 2',
        rebate: 16.192,
        idSuffix: 'annualincome-medium',
        income: '$236,001 - $316,000'
      },
      {
        label: '$316,001 or more (no rebate) (Tier 3)',
        desc: 'No government rebate (Tier 3) will be applied.',
        value: 'high',
        rebate: 0,
        idSuffix: 'annualincome-high',
        income: '$316,001 or more',
        tierLabel: 'Tier 3'
      },
      {
        label: 'Do not apply rebate',
        desc: 'We will not apply Government rebate.',
        value: 'none',
        rebate: 0,
        idSuffix: 'annualincome-none',
        income: '$0',
        tierLabel: ''
      }
    ]
  },

  coverType: [
    {
      label: 'Hospital + Extras',
      value: 'Combined'
    },
    {
      label: 'Hospital only',
      value: 'Hospital'
    },
    {
      label: 'Extras only',
      value: 'Extras'
    }
  ],

  hospitalCoverList: [
    {
      label: 'Private Hospital',
      value: 'private_hospital_shared',
      info: {
        title: 'Private Hospital',
        content: 'Private patient, private hospital admissions.'
      }
    },
    {
      label: 'Ambulance',
      value: 'ambulance',
      info: {
        title: 'Ambulance',
        content: 'Cover for all clinically necessary ambulance services for emergencies in Australia. This differs in states. For more details check with state Ambulance authority to ensure you have the right level of cover for non-emergency ambulance transport within Australia.'
      }
    },
    {
      label: 'Heart and Vascular System',
      value: 'heart_vascular',
      info: {
        title: 'Heart and Vascular System',
        content: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.'
      }
    },
    {
      value: 'eye_not_cataracts',
      label: 'Eye (not cataracts)',
      info: {
        title: 'Eye (not cataracts)',
        content: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.'
      }
    },
    {
      value: 'cancer',
      label: 'Cancer',
      info: {
        title: 'Cancer',
        content: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy of cancer. Surgical treatment of other body systems i.e. lung and chest are covered separately.'
      }
    },
    {
      value: 'joint_replacement',
      label: 'Joint replacements',
      info: {
        title: 'Joint replacements',
        content: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses'
      }
    },
    {
      value: 'rehabilitation',
      label: 'Rehabilitation',
      info: {
        title: 'Rehabilitation',
        content: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.'
      }
    },
    {
      value: 'plastic_reconstructive_surgery',
      label: 'Plastic and Reconstructive Surgery (medically necessary)',
      info: {
        title: 'Plastic and Reconstructive Surgery (medically necessary)',
        content: 'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.'
      }
    },
    {
      value: 'pregnancy_birth',
      label: 'Pregnancy and Birth',
      info: {
        title: 'Pregnancy and Birth',
        content: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth. Treatment for the baby is covered under the clinical category relevant to their condition.'
      }
    },
    {
      value: 'cataracts',
      label: 'Cataracts',
      info: {
        title: 'Cataracts',
        content: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.'
      }
    },
    {
      value: 'dialysis_chronic_kidney',
      label: 'Dialysis for chronic kidney disease',
      info: {
        title: 'Dialysis for chronic kidney disease',
        content: 'Hospital treatment for dialysis treatment for chronic kidney failure.'
      }
    },
    {
      value: 'hearing_device',
      label: 'Implantation of hearing devices',
      info: {
        title: 'Implantation of hearing devices',
        content: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.'
      }
    },
    {
      value: 'assisted_reproductive',
      label: 'Assisted Reproductive Services',
      info: {
        title: 'Assisted Reproductive Services',
        content: 'Hospital treatment for fertility treatments or procedures.'
      }
    },
    {
      value: 'male_reproductive_system',
      label: 'Male Reproductive System',
      info: {
        title: 'Male Reproductive System',
        content: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.'
      }
    },
    {
      value: 'hospital_psychiatric_service',
      label: 'Hospital psychiatric services',
      info: {
        title: 'Hospital psychiatric services',
        content: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.'
      }
    },
    {
      value: 'weight_loss_surgery',
      label: 'Weight loss surgery',
      info: {
        title: 'Weight loss surgery',
        content: 'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.'
      }
    },
    {
      value: 'ear',
      label: 'Ear',
      info: {
        title: 'Ear',
        content: 'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.'
      }
    },
    {
      value: 'ear_nose_throat',
      label: 'Nose and Throat',
      info: {
        title: 'Nose and Throat',
        content: 'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.'
      }
    },
    {
      value: 'pain_management',
      label: 'Pain Management',
      info: {
        title: 'Pain Management',
        content: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device'
      }
    }
  ],

  hospitalCoverLevel: [
    'None',
    'Basic',
    'Bronze',
    'Silver',
    'Gold'
  ],

  hospitalCoverLevelOptions: [
    {
      label: 'Basic',
      value: ['Basic','BasicPlus']
    },
    {
      label: 'Silver',
      value: ['Silver','SilverPlus']
    },
    {
      label: 'Bronze',
      value: ['Bronze','BronzePlus']
    },
    {
      label: 'Gold',
      value: ['Gold']
    },
    {
      label: 'I\'m not sure',
      value: ''
    }
  ],

  extraCoverLevel: [
    'None',
    'Low',
    'Medium',
    'High'
  ],

  extrasCoverList: [
    {
      label: 'General Dental',
      value: 'general_dental'
    },
    {
      label: 'Major Dental',
      value: 'major_dental'
    },
    {
      label: 'Optical',
      value: 'optical'
    },
    {
      label: 'Physiotherapy',
      value: 'physiotherapy'
    },
    {
      label: 'Chiropractic and Osteopathy',
      value: 'chiropractic'
    },
    {
      label: 'Remedial Massage',
      value: 'remedial_massage'
    },
    {
      label: 'Pharmaceuticals',
      value: 'pharmaceuticals'
    },
    {
      label: 'Psychology',
      value: 'psychology'
    },
    {
      label: 'Podiatry',
      value: 'podiatry_therapy'
    },
    {
      label: 'Acupuncture',
      value: 'acupuncture'
    },
    {
      label: 'Hearing Aids',
      value: 'hearing_aids'
    },
    {
      label: 'Other Aids',
      value: 'glucose_monitor'
    }
  ],

  extrasCoverLevelOptions: [
    {
      label: '$750',
      value: '750'
    },
    {
      label: '$500',
      value: '500'
    },
    {
      label: '$250',
      value: '250'
    },
    {
      label: '$0',
      value: '0'
    },
    {
      label: 'I\'m not sure',
      value: ''
    }
  ],

  quickTips: {
    1: [
      'We are Australian owned.',
      'We make <strong>switching easy</strong>.',
      'We\'ve been helping Aussies save on their health insurance <strong>since 2010</strong>.'
    ],
    2: [
      '<strong>Compare Club</strong> compares selected products from a panel of trusted insurers. We do not compare all insurers or all products in the market.',
      'We\'re <strong>independently owned</strong>. Unlike some of our competitors, we aren\'t owned by any insurers (or vice versa).'
    ]
  },

  visaType: {
    visitor: [
      '600 - Visitor',
      '601 - Electronic Travel Authority',
      '461 - New Zealand Citizen Family Relationship (temporary) visa',
      '651 - eVisitor',
      '771 - Transit visa',
      '804 - Aged Parent visa',
      '870 - Sponsored Parent (Temporary) visa',
      '884 - Contributory Aged Parent (Temporary) visa',
      '866 - Protection visa'
    ],
    working: [
      '408 - Temporary Activity visa',
      '482 - Temporary Skill Shortage visa',
      '491 - Skilled Work Regional (Provisional) visa',
      '485 - Temporary Graduate visa',
      '407 - Training visa',
      '417 - Working Holiday visa',
      '462 - Work and Holiday visa',
      '188 - Business Innovation and Investment (provisional) visa',
      '190 - Skilled Nominated visa'
    ],
    student: [
      '500 - Student visa',
      '485 - Temporary Graduate visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '580 - Student Guardian visa'
    ],
    others: [
      '10 - Bridging visa A – BVA',
      '20 - Bridging visa B – BVB',
      '30 - Bridging visa C – BVC',
      '50 - Bridging visa E – BVE',
      '101 - Child visa',
      '102 - Adoption visa',
      '103 - Parent visa',
      '114 - Aged Dependent Relative visa',
      '115 - Remaining Relative visa',
      '116 - Carer visa',
      '117 - Orphan Relative',
      '119 - Regional Sponsor Migration Scheme',
      '120 - Labour Agreement visa',
      '121 - Employer Nomination Scheme',
      '124 - Distinguished Talent visa',
      '132 - Business Talent (Permanent) visa',
      '143 - Contributory Parent visa',
      '151 - Former Resident visa',
      '155 - Resident Return visa',
      '160 - Business Skills (Provisional) visa',
      '173 - Contributory Parent (Temporary) visa',
      '175 - Skilled Independent visa',
      '176 - Skilled Sponsored visa',
      '186 - Employer Nomination Scheme',
      '187 - Regional Sponsored Migration Scheme',
      '189 - Skilled Independent visa',
      '191 - Permanent Residence (Skilled Regional) visa',
      '200 - Refugee visas',
      '202 - Global Special Humanitarian',
      '300 - Prospective Marriage visa',
      '309 - Partner (Provisional and Migrant) visa',
      '400 - Temporary Work (Short Stay Specialist) visa',
      '401 - Temporary Work (long Stay Activity) visa',
      '402 - Training and Research visa',
      '403 - Temporary Work (International Relations) visa',
      '405 - Investor Retirement visa',
      '406 - Government Agreement visa',
      '410 - Retirement visa',
      '411 - Exchange visa',
      '415 - Foreign Government Agency',
      '416 - Special Program visa ',
      '419 - Visiting Academic visa',
      '420 - Temporary Work (Entertainment) visa',
      '421 - Sport visa',
      '422 - Medical Practitioner visa',
      '423 - Media and Film Staff visa',
      '426 - Domestic Worker (Temporary) Diplomatic and Consular visa',
      '427 - Domestic Worker (Temporary) Executive visa',
      '428 - Religious Worker visa',
      '444 - Special Category visa',
      '445 - Dependent Child visa',
      '456 - Business (Short Stay) visa',
      '457 - Temporary Work (Skilled) visa',
      '475 - Skilled Regional Sponsored visa',
      '476 - Skilled-Recognised Graduate visa',
      '487 - Skilled Regional Sponsored',
      '488 - Superyacht Crew visa',
      '489 - Skilled Regional (provisional) visa',
      '494 - Skilled Employer Sponsored Regional (provisional) visa',
      '495 - Skilled Independent Regional (Provisional) visa',
      '496 - Skilled Designated Area Sponsored visa',
      '570 - Independent ELICOS Sector visa',
      '571 - School Sector visa',
      '572 - Vocational Education and Training Sector visa',
      '573 - Higher Education Sector visa',
      '574 - Postgraduate Research Sector visa',
      '575 - Non Award Sector visa',
      '576 - Foreign Affairs or Defence sector visa',
      '580 - Student Guardian visa',
      '590 - Student Guardian visa',
      '602 - Medical Treatment visa',
      '675 - Medical Treatment (Short Stay) visa',
      '676 - Tourist visa',
      '685 - Medical Treatment Long Stay visa',
      '785 - Temporary Protection visa',
      '790 - Safe Haven Enterprise visa',
      '802 - Child visa',
      '808 - Confirmatory (Residence) visa',
      '820 - Partner visa',
      '835 - Remaining Relative visa',
      '836 - Carer visa',
      '837 - Orphan Relative',
      '838 - Aged Dependent Relative visa',
      '845 - Established Business in Australia visa',
      '846 - State or Territory Sponsored Regional Established Business in Australia visa',
      '855 - Labour Agreement visa',
      '858 - Global Talent visa',
      '864 - Contributory Aged Parent visa',
      '885 - Skilled Independent visa',
      '886 - Sponsored visa',
      '887 - Skilled Regional visa',
      '888 - Business Innovation and Investment (permanent) visa',
      '890 - Business Owner',
      '891 - Investor visa',
      '892 - State or Territory Sponsored Business Owner visa',
      '893 - State or Territory Sponsored Investor visa',
      '942 - Crew Travel Authority visa',
      '956 - Electronic Travel Authority (Business Entrant) visa',
      '976 - Electronic Travel Authority (Visitor) visa',
      '988 - Maritime Crew visa'
    ]
  },

  didYouKnow: 'Over the last 12 months, we\'ve helped families in Sydney\'s inner west <strong>save an average of $300</strong> on hospital and extras cover.',

  ovhcOffers: [
    'Satisfy Australian Government visa requirements',
    'Receive your visa compliance letter instantly by email',
    'Cut down on medical costs and protect your health Australia-wide'
  ],

  // stepsToFollow: [
  //   {
  //     imageUrl: require('~/static/images/steps/find-cover.svg'),
  //     text: 'Find Cover You Want',
  //     desc: 'Enter a few details and we’ll help you find the policies that better suits your needs.'
  //   },
  //   {
  //     imageUrl: require('~/static/images/steps/simple-comparison.svg'),
  //     text: 'Simple Comparison',
  //     desc: 'Let us know what type of cover you would like and we\'ll let you know what you\'ll be covered for.'
  //   },
  //   {
  //     imageUrl: require('~/static/images/steps/get-quotes.svg'),
  //     text: 'Avoid Hefty Bills',
  //     desc: 'Overseas Visitors Health Cover can help you avoid hefty health care bills.'
  //   },
  //   {
  //     imageUrl: `${APP_ASSET_BASEURL}edge/static/images/steps/approval.svg`,
  //     text: 'Meet Visa Requirements',
  //     desc: 'We only offer policies that fulfill the visa requirements set by the Australian Government.'
  //   }
  // ],

  criteriaList: [
    'Provides public hospital cover at <strong>a minimum</strong>',
    'Includes cover for <strong>emergency ambulance transport</strong>',
    '<strong>Covers all medications</strong> covered by the Pharmaceutical Benefits Scheme (PBS)',
    '<strong>Covers all treatments</strong> listed under the Medicare Benefits Schedule (MBS)'
  ],

  ovhcFaqs: [
    {
      title: 'What visas are covered under Overseas Visitors Health Cover (OVHC)?',
      content: `
        We cover all ‘active’ visas, such as working visas (485, 482, 408) and visitor visas (600, 601).
        <br /><br />
        There are some visas that are no longer active which health funds won’t cover, and you can’t get cover for any visa that has access to Medicare, such as visa 804 and visa 864.
      `
    },
    {
      title: 'Can I organise my cover before coming to Australia?',
      content: 'Yes. Our experts are able to help you get your cover sorted before coming to Australia, and you can call us internationally to get it sorted. We can even help with a certificate of insurance if that’s needed for your visa type.'
    },
    {
      title: 'When can I start using my cover?',
      content: `
        Your membership will commence on the date you nominated as the cover start date, even if your membership card has not arrived. However you should note that waiting periods will apply before you can make a claim.
        <br /><br />
        You will have seen these when you compared insurers, however the information will also be available in the welcome email sent by your chosen insurer.
      `
    },
    {
      title: 'Does Overseas Visitor Health Cover include extras, such as dental and optical?',
      content: 'Most policies do not include extras, but can be added to the cover if required. Most Overseas Visitors Health Cover includes hospital and ambulance with the option to add benefits for doctors, specialists and pathology (blood tests).'
    },
    {
      title: 'How do I make an Overseas Visitors Health Cover claim?',
      content: `
        It depends on your insurer, but you can make a claim by providing the receipt and claiming online or through the insurer’s mobile app.
        <br /><br />
        However, most doctors and General Practitioners will recognise some health funds and let you claim on the spot with your membership card.
      `
    },
    {
      title: 'What happens if the date I\'m arriving in Australia changes?',
      content: 'All you have to do is contact your insurer or us prior to the start date of your cover so it can be changed. You should do this as soon as you know about the delay.'
    },
    {
      title: 'When will I be charged?',
      content: `
        You will be billed for your first month as soon as you sign up for your policy to confirm your cover. This payment will cover the month that follows your policy start date.
        <br /><br />
        When this period ends, you will be charged for the next billing period, which may be fortnightly or monthly.
      `
    },
    {
      title: 'What if my membership card doesn\'t arrive before I leave my overseas address?',
      content: `
        If you were overseas at the time of purchase and in transit at the time your membership card/s arrive, you can always contact us or your fund once you arrive in Australia and ask for your cards to be reissued.
      `
    },
    {
      title: 'Is there a difference between Overseas Visitors Health Cover (OVHC) and Overseas Students Health Cover (OSHC)?',
      content: `
        Yes, there is.
        <br /><br />
        <ul class="list-disc pl-8">
          <li class="mb-2">
            <strong>Overseas Visitors Health Cover</strong> is a month to month health insurance and has limited options as to what can be included in your cover.
          </li>
          <li>
            <strong>Overseas Students Health Cover</strong> is for student visas and must be paid upfront for the length of time the visa is active. For example, if your visa is for two years, you must pay two years upfront. All people on the visa must also be included on the cover. If you want to learn more, please read our guide.
          </li>
        </ul>
      `
    }
  ],

  healthFaqs: [
    {
      title: 'I\'ve purchased a product through Compare Club, what do I do next?',
      content: 'In most cases, all documentation is provided over the phone with your Club+ agent. The only thing you may need to do on your own is complete your Government Rebate application. Depending on the fund you go with, this could take the form of:' +
        '<ul class="list-disc pl-8 my-8">' +
        '<li>An activation email</li>' +
        '<li>A voice recording via the fund’s call centre</li>' +
        '<li>Filling out a form</li>' +
        '</ul>Please check the email we sent you for information relating to your new health fund. If you need more help, call us on 1300 757 819. We’re always happy to assist.'
    },
    {
      title: 'Why does the information in my welcome pack show waiting periods?',
      content: 'Your welcome pack will display generic information until your old fund sends a clearance certificate through to your new fund. Once this certificate is received, your new fund applies it to your membership and your waiting periods are updated or removed entirely. If you receive a copy of your clearance certificate and want to speed up this process, you can either send it to your new fund directly, or send it over to us so we can update the details on your behalf. Too easy!'
    },
    {
      title: 'When will I get my refund?',
      content: 'Generally speaking, once your old health fund receives our request for transfer, they have 14 days to release your clearance certificate. Once this is done, your refund is released automatically. If your reimbursement details are in place, your refund goes right back into your account. If not, you’ll be sent a cheque.'
    },
    {
      title: 'Will I be double deducted?',
      content: 'This happens rarely, but it can occur when your previous fund doesn’t action your cancellation quickly enough. If you’re paying via direct debit, some banks will allow you to put a temporary block on the previous fund’s withdrawals, which stops that deduction from coming out. For more information, reach out to 1300 757 819.'
    },
    {
      title: 'Can I claim right away?',
      content: 'This depends on what you’re claiming. If you’re claiming an extras benefit within the first two weeks of joining a new fund, it’s best to pay upfront and then claim for the service once your new fund has received your clearance certificate and your new membership is up-to-date. If you upgrade your cover (whether changing funds or staying with the same fund) waiting periods may apply. Read your policy documentation carefully, or feel free to reach out to us for more information at 1300 757 819.'
    },
    {
      title: 'My old fund has sent me documentation that I don\'t understand!',
      content: 'Give us a call and we’ll happily walk you through it. We speak fluent health policy!'
    },
    {
      title: 'Is there a cooling-off period when I can cancel my new policy?',
      content: '<p>Absolutely. All health insurance policies in Australia come with a 30-day cooling-off period. To cancel, you can just get in touch with our team at <a class="underline" href="mailto:insurance@compareclub.com.au">insurance@compareclub.com.au</a>, or call your new health fund directly within the first 30 days of your new cover. Provided you’ve not made any claims since joining your new fund, you’ll get a full refund of any premiums you’ve already paid.</p><br/><p>Please contact us at <a class="underline" href="tel:1300757819">1300 757 819</a> or email us at <a class="underline" href="mailto:insurance@compareclub.com.au">insurance@compareclub.com.au</a> if you require any further information. </p><br><p>Compare Club prides itself on high-quality customer service, but in the event that you need to make a complaint, please read our complaints and dispute resolution information. Visit: <a class="underline" target="_blank" href="https://compareclub.com.au/complaints/">How to complain to Compare Club</a>.</a></p>'
    },
    {
      title: 'When will I get my gift card?',
      content: '<p>If you qualify for an incentive and purchased your policy before 1st Aug 2023, you’ll receive it in your email inbox after you’ve held your policy for 90 days. <br/> If you qualify for an incentive and purchased your policy on or after 1st Aug 2023, you’ll see it in your Gift Cards page with a “Pending” status, counting down to when you’ll be able to claim it. See the <a class="underline cursor-pointer" href="/dashboard/rewards/">Gift Cards page</a> for more details</p>'
    }],

  coverHealthLength: [
    'Less than 1 year',
    '1-3 years',
    '3-5 years',
    '5+ years'
  ],

  title: ['Mr', 'Ms', 'Mrs', 'Dr'],

  dualRateStartDate: '11/01/2023',
  dualRatesEndDate: '01/01/2024',

  contactIn: [
    '3 months',
    '6 months',
    '1 year',
    '2 years',
    '3 years'
  ],
  policyProviders: {
    nib: {
      title: 'nib',
      subtitle: 'You\'re joining one of Australia\'s largest health funds. NIB\'s based in Newcastle and has been around since 1952, so you\'re in good hands.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/NIB-update.svg`,
      points: [
        '<p>With NIB extras cover, You\'ll get <strong>100% back</strong> on optical and dental (up to your annual limit) when you visit a NIB eye care or dental care centre.</p>'
      ]
    },
    bupa: {
      title: 'bupa',
      subtitle: 'you’ve joined Bupa, which is one of the largest health insurers in Australia. They have more than 4 million members and were founded in 1947.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/BUPA.svg`,
      points: [
        '<p>As a <strong>Bupa member,</strong> you receive access to Bupa Plus, a loyalty program with discounts and offers from over 40 partners. Some partners include Hoyts, Garmin, Pet Circle and Booktopia.</p>',
        '<p>With <strong>Bupa Extras cover,</strong> you can claim up to 100% through Bupa’s Members First Providers, which include dentists, chiropractors, physiotherapists, and more.</p>'
      ]
    },
    ahm: {
      title: 'ahm',
      subtitle: 'you’ve joined AHM health insurance, which provides health cover to more than 700,000 members. AHM was originally founded in Wollongong over 40 years ago, and is backed by Medibank.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/AHM.svg`,
      points: [
        '<p>As an <strong>AHM member,</strong> you receive a percentage off your glasses and contact lenses at OPSM and Specsavers.</p>',
        '<p>There are <strong>7 extras plans</strong> to choose from, with budget for the bare essentials to plans that cover unlimited preventative dental.</p>'
      ]
    },
    peoplecare: {
      title: 'Peoplecare',
      subtitle: 'you’ve joined Peoplecare, which is a not-for-profit mutual fund, 100% owned by more than 34,000 members. They were founded in 1952.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/Peoplecare.svg`,
      points: [
        '<p>As a <strong>Peoplecare member,</strong> you have access to a new search tool that helps you find doctors with low gap fees for surgeries.</p>',
        '<p>There are <strong>discounts available</strong> to members on optical, dental, and more. You can get a discount at Specsavers, OPSM, smile.com.au and Eyebenefit, just to name a few.</p>'
      ]
    },
    hcf: {
      title: 'HCF',
      subtitle: 'you’ve joined HCF, which stands for Hospitals Contribution Fund and was founded in 1932. They provide health insurance to more than 1.6 million Australians.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/HCF.svg`,
      points: [
        '<p>If you have <strong>HCF Extras cover,</strong> you can get up to 100% back on 1 or 2 dental check-ups per year.</p>',
        '<p>You also have access to <strong>HCF’s loyalty rewards</strong> program, HCF Thank You, which includes discounts at Hoyts, popular supermarkets and other retailers.</p>'
      ]
    },
    gmhba: {
      title: 'GMHBA',
      subtitle: 'you’ve joined GMHBA, which is an Australian-owned not for profit health insurer that’s been running for more than 85 years.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/GMHBA.svg`,
      points: [
        '<p>GMHBA have <strong>partnered</strong> with AIA Vitality, a health and wellbeing program, where you can be rewarded for your healthy habits.</p>',
        '<p>GMHBA also offers many <strong>health programs</strong> for their members, including a Chronic Disease Management Program, Hospital In The Home and Rehab In The Home.</p>'
      ]
    },
    au: {
      title: 'Australian Unity',
      subtitle: 'you’ve joined Australian Unity, which was founded over 180 years ago. They are Australia’s first member-owned wellbeing company and have over 300,000 members across the country.',
      logo: `${APP_ASSET_BASEURL}health-insurance/partners/Australia-Unity.svg`,
      points: [
        '<p>Australian Unity <strong>offers members</strong> a range of health programs depending on your level and length of cover, including free mental health support and preparing for parenthood.</p>',
        '<p>You have access to the <strong>Wellplan Rewards</strong> loyalty program which offers a range of discounts across popular retailers, including groceries and alcohol.</p>'
      ]
    }
  }
}

export const FORM_STEPS = {
  health_insurance: [
    'About You',
    'Cover Details',
    'Compare',
    'Apply',
    'Finish'
  ],
  ovhc: [
    'Start',
    'Your Cover',
    'Your Details',
    'Submit'
  ],
  'ovhc-application': [
    {
      label: 'Compare',
      icon: '/icons/life-insurance/compare-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Your Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Health Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Visa Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Payment Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Complete',
      icon: '/icons/life-insurance/complete-card.svg',
      iconDimensions: {
        width: 17,
        height: 20
      }
    }
  ],
  'hic-application': [
    {
      label: 'Compare',
      icon: '/icons/life-insurance/compare-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Your Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Rebate Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'LHC Loading',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Medicare Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Payment Details',
      icon: '/icons/life-insurance/love-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Submit',
      icon: '/icons/life-insurance/complete-card.svg',
      iconDimensions: {
        width: 17,
        height: 20
      }
    }
  ],
  'hic-comparison': [
    {
      label: 'About You',
      icon: '/icons/identity-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Compare',
      icon: '/icons/compare-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Apply',
      icon: '/icons/apply-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Submit',
      icon: '/icons/complete-card.svg',
      iconDimensions: {
        width: 16,
        height: 16
      }
    }
  ],
  'ovhc-comparison': [
    {
      label: 'Compare',
      icon: '/icons/compare-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Your Details',
      icon: '/icons/identity-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Health Details',
      icon: '/icons/identity-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Visa Details',
      icon: '/icons/identity-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Payment Details',
      icon: '/icons/apply-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Complete',
      icon: '/icons/complete-card.svg',
      iconDimensions: {
        width: 16,
        height: 16
      }
    }
  ]
}

export const ERROR_MAP = {
  health_insurance: {
    step1: {
      life_stage: 'Please select an option',
      postcode: 'Please enter valid postcode or suburb'
    },
    step2: {
      has_health_fund: 'Please select an option',
      health_fund: 'Please select health fund',
      partner_has_health_fund: 'Please select an option',
      partner_health_fund: 'Please select health fund',
      health_cover: 'Please select option(s)',
      birthdate: 'Please enter valid date of birth',
      partner_birthdate: 'Please enter valid date of birth',
      income: 'Please select an option'
    },
    step3: {
      cover_type: 'Please select an option',
      hospital_cover_list: 'Please select the services',
      extras_cover_list: 'Please select the services',
      contact_in: 'Please select an option'
    },
    hospital_cover_level: 'Please select an option',
    extra_cover_level: 'Please select an option',
    premium_amount: 'Please enter your premium amount',
    current_cover: 'Please select an option'
  },

  ovhc: {
    step1: {
      life_stage: 'Please select what you\'re looking for',
      visa_type: 'Please select your visa type',
      visa_subtype: 'Please select your visa subclass',
      visa_code: 'Please input your visa code'
    },
    step2: {
      already_in_australia: 'Please select an option',
      country_of_citizenship: 'Please select your country',
      cover_level: 'Please select an option',
      state_in_australia: 'Please select your state',
      date_of_birth: 'Please enter your valid date of birth',
      expected_entry_date: 'Please enter your date of arrival',
      include_pregnancy_related_cover: 'Please select an option'
    }
  },

  details: {
    full_name: 'Full name field is required.',
    email: 'Please enter a valid email address.',
    phone: 'Please enter a valid number.'
  },

  ovhc_application: {
    step1: {
      title: 'Please select title',
      email: 'Please input correct email',
      passportNumber: 'Please input your passport number',
      gender: 'Please select gender',
      first_name: 'Please enter first name',
      last_name: 'Please enter last name',
      preferred_contact: 'Please select preferred method of contact',
      has_australian_mailing_address: 'Please select australian mailing address',
      australian_address: 'Please input your address',
      area_code: 'Enter valid code',
      number: 'Please enter a valid contact number',
      address_line: 'Please input valid address',
      suburb: 'Please input valid suburb',
      postcode: 'Please enter your valid postcode',
      overseas_address_line1: 'At least 1 address line must be filled',
      overseas_address_line2: 'At least 1 address line must be filled',
      overseas_city: 'City is required',
      overseas_state: 'State/Province is required',
      overseas_postcode: 'Post Code is required',
      overseas_country: 'Please select country'
    },

    step2: {
      partner_title: 'Please select title',
      partner_gender: 'Please select gender',
      partner_first_name: 'Please enter first name',
      partner_last_name: 'Please enter last name',
      partner_birthdate: 'Birthdate must be in the format DD/MM/YYYY'
    },

    step3: {
      existing_health_insurance: 'Please answer this question',
      current_health_fund: 'Please select your current Overseas Visitors health insurer',
      current_membership_number: 'Fund Membership Number is required',
      pre_existing_conditions: 'Please answer this question',
      allow_fund_contact: 'Please allow us to contact fund'
    },

    step4: {
      visa_sub_type: 'Visa sub type is required',
      visa_sub_class: 'Visa sub class is required',
      visa_grant_date: 'Visa grant date is required',
      cover_start_date: 'Estimated cover start date is required',
      sponsor_name: 'Sponsor name is required',
      sponsor_email: 'Please enter valid email',
      sponsor_phone: 'Please enter valid phone number'
    },

    step5: {
      payment_frequency: 'Please select from the options',
      payment_type: 'Please select from the options',
      cardholder_name: 'Please input card holder name',
      card_number: 'Please input card number',
      card_exp_date: 'Please input valid date',
      card_cvv: 'Please input your cvv',
      bank_name: 'Please input bank name',
      bank_account_holder_name: 'Please input account name',
      bank_account_number: 'Please input valid bank number',
      bank_bsb: 'Please input valid bsb number'
    }
  },

  ovhc_children: {
    child_title: 'Please select your child\'s title',
    child_gender: 'Please select your child\'s gender',
    child_first_name: 'Please enter your child\'s first name',
    child_last_name: 'Please enter your child\'s last name',
    child_birth_date: 'Birthdate must be in the format DD/MM/YYYY'
  }
}

export const SUMMARY_MAP = {
  life_stage: {
    label: 'Cover for',
    icon: 'user-pin'
  },
  postcode: {
    label: 'Postcode',
    icon: 'location-outline'
  },
  birthdate: {
    label: 'DOB',
    icon: 'home-heart'
  },
  partner_birthdate: {
    label: 'Partner\'s DOB',
    icon: 'home-heart'
  },
  has_health_fund: {
    label: 'Insurance Cover',
    icon: 'file-new'
  },
  health_fund: {
    label: 'Insurance Cover',
    icon: 'file-new'
  },
  partner_has_health_fund: {
    label: 'Partner\'s Insurance Cover',
    icon: 'file-new'
  },
  health_cover: {
    label: 'Health Cover',
    icon: 'file-new'
  },
  income: {
    label: 'Yearly Income',
    icon: 'income'
  },
  cover_type: {
    label: 'Cover Type',
    icon: 'file-new'
  },
  hospital_cover_list: {
    label: 'Hospital Cover List',
    icon: 'file-new'
  },
  extras_cover_list: {
    label: 'Extra Cover Type',
    icon: 'file-new'
  }
}

export const OVHC_APPLICATION_SUMMARY_MAP = {
  full_name: {
    label: 'Primary Applicant',
    icon: 'icon-user'
  },
  partner_full_name: {
    label: 'Partner',
    icon: 'icon-user'
  },
  dependant: {
    label: 'Dependant',
    icon: 'icon-user'
  },
  existing_insurance: {
    label: 'Existing insurance',
    icon: 'plus'
  },
  current_membership_number: {
    label: 'Membership number',
    icon: 'swiss-cross'
  },
  pre_existing_conditions: {
    label: 'Pre-existing health conditions',
    icon: 'file-new'
  },
  life_stage: {
    label: 'Cover for',
    icon: 'user-pin',
    showEdit: false
  },
  visa_type: {
    label: 'Visa type',
    icon: 'icon-park',
    showEdit: false
  },
  visa_subtype: {
    label: 'Visa subclass',
    icon: 'icon-park',
    showEdit: false
  },
  country_of_citizenship: {
    label: 'Country',
    icon: 'user-pin',
    showEdit: false
  },
  already_in_australia: {
    label: 'Currently in Australia',
    icon: 'location-outline',
    showEdit: false
  },
  include_pregnancy_related_cover: {
    label: 'Pregnancy cover',
    icon: 'file-new',
    showEdit: false
  },
  date_of_birth: {
    label: 'DOB',
    icon: 'home-heart',
    showEdit: false
  },
  cover_level: {
    label: 'Cover level',
    icon: 'file-new',
    showEdit: false
  }
}

export const OVHC_APPLICATION_REVIEW_MAP = {
  name: {
    label: 'Name'
  },
  dob: {
    label: 'DOB'
  },
  phone: {
    label: 'Phone'
  },
  pre_existing_conditions: {
    label: 'Has Pre-existing Health Conditions'
  },
  visa_sub_type: {
    label: 'Visa Type'
  },
  cover_start_date: {
    label: 'Estimated cover start date'
  },
  sponsor_name: {
    label: 'Sponsor\'s name'
  },
  sponsor_email: {
    label: 'Sponsor\'s email'
  },
  sponsor_phone: {
    label: 'Sponsor\'s phone'
  }
}

export const HEALTH_INSURANCE_FORM_DETAILS = {
  step1: {
    header: {
      tag: 'free',
      title: `
            <strong class="font-extrabold">Health insurance</strong> quotes in
            <strong class="font-extrabold">under 2 minutes!</strong>
          `,
      component: 'div'
    }
  },
  step2: {
    header: {
      title: 'Tell us a bit more about',
      component: 'AtomsHeadline'
    }
  },
  step3: {
    header: {
      title: 'Make your <strong class="font-extrabold">health cover work</strong> for you.',
      component: 'AtomsHeadline'
    }
  }
}

export const HEALTH_INSURANCE_FORM_QUESTIONS = {
  lifeStage: {
    question: 'Your health insurance cover is for',
    desc: 'If you tell us what\'s important to you, it\'ll help us figure out the right health insurance policy for you.',

    component: 'MoleculesSelection',
    props: {
      name: 'life_stage',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.lifeStage
    }
  },
  postcode: {
    question: 'Enter your postcode or suburb',
    desc: 'Your location can make a difference to the availability of healthcare providers allied to your current - or new - health fund.',
    component: 'MoleculesPostcode',
    props: {
      label: 'Postcode or suburb'
    }
  },
  hasHealthFund: {
    question: 'Do you have health cover?',
    desc: 'This helps our experts better understand your needs and compare suitable policies from our panel. We can also factor in things like Lifetime Health Cover Loading (LHCL) if you don\'t currently hold health cover.',

    component: 'MoleculesSelection',
    props: {
      name: 'has_health_fund',
      type: 'radio',
      ticker: 'circle',
      options: ['Yes', 'No']
    }
  },
  healthFund: {
    question: 'Select your current health fund',

    component: 'MoleculesSelectDropdown',
    props: {
      label: 'Select Health Fund',
      dataListDisplay: 'label',
      dataInputDisplay: 'label',
      // dataValue: 'value',
      dataSrc: 'https://asset.compareclub.com.au/json/health-funnel-funds.json'
    }
  },
  partnerHasHealthFund: {
    question: 'Does your partner have health cover?',
    desc: 'If you tell us what\'s important to you, this helps us figure out the right health insurance match for you and your partner as a couple.',

    component: 'MoleculesSelection',
    props: {
      name: 'partner_has_health_fund',
      type: 'radio',
      ticker: 'circle',
      options: ['Yes', 'No']
    }
  },
  partnerHealthFund: {
    question: 'Select your partner\'s health fund',

    component: 'MoleculesSelectDropdown',
    props: {
      name: 'partner_health_fund',
      label: 'Select Health Fund',
      dataListDisplay: 'label',
      dataInputDisplay: 'label',
      // dataValue: 'value',
      dataSrc: 'https://asset.compareclub.com.au/json/health-funnel-funds.json'
    }
  },
  healthCover: {
    question: 'What are your main considerations when looking for new health insurance?',
    desc: 'Tell us what\'s important to you. It helps our experts find the right policy match for you. You can select multiple options.',

    component: 'MoleculesSelection',
    props: {
      type: 'checkbox',
      options: PAGE_DATA.healthCover
    }
  },
  birthdate: {
    question: 'What is your date of birth?',
    desc: 'Your age helps us figure out what cover could be the most valuable for you.',

    component: 'MoleculesBirthdate',
    props: {
      label: 'Your date of birth',
      placeholder: 'Enter your date of birth (dd/mm/yyyy)',
      validAge: PAGE_DATA.validAge,
      disableDatepicker: true
    }
  },
  partnerBirthdate: {
    question: 'What is your partner\'s date of birth?',
    desc: 'This information helps us work out which policies are the most relevent for you and your partner.',

    component: 'MoleculesBirthdate',
    props: {
      label: 'Date of birth',
      placeholder: 'Enter your partner\'s date of birth (dd/mm/yyyy)',
      validAge: PAGE_DATA.validAge,
      disableDatepicker: true
    }
  },
  income: {
    question: 'What is your annual taxable income?',
    desc: 'This is to help calculate your health insurance rebate. The level of government rebate you can claim is based on your yearly household (taxable) income and your age.',
    component: 'MoleculesSelection',
    props: {
      name: 'income',
      type: 'radio',
      ticker: 'circle',
      options: []
    }
  },
  coverType: {
    question: 'Select the type of Cover',
    desc: 'Choose your preferred cover type.',
    component: 'MoleculesSelection',
    props: {
      name: 'cover_type',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.coverType
    }
  },
  hospitalCoverList: {
    question: 'What hospital services do you want covered?',
    desc: `
      Choose what services you'd like to be covered for today and into the future. We'll then find a quote that matches your needs. Need help? Our experts are on hand to answer any questions
    `,

    component: 'MoleculesSelection',
    props: {
      type: 'checkbox',
      options: PAGE_DATA.hospitalCoverList,
      inline: true,
      infoShowAction: 'hover'
    }
  },
  extrasCoverList: {
    question: 'What extras services do you need cover for?',
    desc: `
      Choose what services you're likely to use over the next 12 months. Got questions? Our experts are on hand to help you compare benefits, annual limits and coverage.
    `,

    component: 'MoleculesSelection',
    props: {
      type: 'checkbox',
      options: PAGE_DATA.extrasCoverList,
      inline: true
    }
  },
  contactIn: {
    question: 'Before we give you a quote we want to get your consent to contact you about certain insurance products.',
    desc: 'Pick a time period below that you\'re happy to consent to.',
    component: 'MoleculesSelection',
    props: {
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.contactIn,
      inline: true,
      name: 'contact-in'
    }
  }
}

export const HEALTH_INSURANCE_FORM_ITEMS = {
  step1: {
    form: (() => {
      const {
        lifeStage,
        postcode
      } = HEALTH_INSURANCE_FORM_QUESTIONS

      return {
        lifeStage,
        postcode
      }
    })()
  },

  step2: {
    form: (() => {
      const {
        hasHealthFund,
        healthFund,
        partnerHasHealthFund,
        partnerHealthFund,
        healthCover,
        birthdate,
        partnerBirthdate,
        income
      } = HEALTH_INSURANCE_FORM_QUESTIONS

      return {
        hasHealthFund,
        healthFund,
        partnerHasHealthFund,
        partnerHealthFund,
        healthCover,
        birthdate,
        partnerBirthdate,
        income
      }
    })()
  },

  step3: {
    form: (() => {
      const {
        coverType,
        hospitalCoverList,
        extrasCoverList
      } = HEALTH_INSURANCE_FORM_QUESTIONS

      return {
        coverType,
        hospitalCoverList,
        extrasCoverList
      }
    })()
  }
}

export const DEAL_ALERTS_QUESTIONS = {
  lifeStage: {
    question: 'Your health insurance cover is for:',

    component: 'MoleculesSelection',
    props: {
      name: 'life_stage',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.lifeStage
    }
  },
  postcode: {
    question: 'Enter your postcode or suburb',
    component: 'MoleculesPostcode',
    props: {}
  },
  healthCover: {
    question: 'What is your main consideration when looking for a new health insurance cover?',
    component: 'MoleculesSelection',
    props: {
      type: 'checkbox',
      options: PAGE_DATA.healthCover
    }
  },
  birthdate: {
    question: 'What is your date of birth?',
    component: 'MoleculesBirthdate',
    props: {
      label: 'Date of birth',
      placeholder: 'Enter your date of birth (dd/mm/yyyy)',
      validAge: PAGE_DATA.validAge
    }
  },
  partnerBirthdate: {
    question: 'What is your partner\'s date of birth?',

    component: 'MoleculesBirthdate',
    props: {
      label: 'Date of birth',
      placeholder: 'Enter your partner\'s date of birth (dd/mm/yyyy)',
      validAge: PAGE_DATA.validAge
    }
  },
  income: {
    question: 'What is your annual taxable income?',
    desc: 'This is to help calculate your health insurance rebate. The level of government rebate you can claim is based on your yearly household (taxable) income and your age.',

    component: 'MoleculesSelection',
    props: {
      name: 'income',
      type: 'radio',
      ticker: 'circle',
      options: []
    }
  },
  healthFund: {
    question: 'Select your current health fund',

    component: 'MoleculesSelectDropdown',
    props: {
      label: 'Select Health Fund',
      dataListDisplay: 'label',
      dataInputDisplay: 'label',
      dataSrc: 'https://asset.compareclub.com.au/json/health-funnel-funds.json'
    }
  },
  hospitalCoverLevel: {
    question: 'What hospital cover level do you currently have?',

    component: 'MoleculesSelection',
    props: {
      name: 'hospital-cover-level',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.hospitalCoverLevel
    }
  },
  extraCoverLevel: {
    question: 'What extras cover level do you currently have?',

    component: 'MoleculesSelection',
    props: {
      name: 'extras-cover-level',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.extraCoverLevel
    }
  },
  premiumAmount: {
    question: 'What monthly premium amount do you currently pay?',

    component: 'AtomsInput',
    props: {
      name: 'premium_amount',
      placeholder: 'Enter premium amount',
      modelType: 'money',
      label: '',
      hasCurrency: true
    }
  },
  currentCover: {
    question: 'How long have you been insured under your current cover?',

    component: 'MoleculesSelection',
    props: {
      name: 'current-cover-length',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.coverHealthLength
    }
  }
}

export const OVHC_FORM_ITEMS = {
  step1: {
    header: {
      title: `
        <strong class="font-extrabold">Compare Overseas Visitors</strong> <br class="hidden lg:block" />
        Health Cover with our<br class="hidden lg:block" />
        <strong class="font-extrabold">Experts & Save </strong>
      `,
      desc: '<strong>Tell us what cover you would like</strong> and we\'ll help you compare the best deals from multiple Australian providers.'
    },
    buttons: {
      main: 'LET\'S GET STARTED',
      back: true
    },
    list: PAGE_DATA.ovhcOffers,
    form: (() => {
      const lifeStage = {
        question: 'I am looking for',

        component: 'MoleculesSelectDropdown',
        props: {
          name: 'life_stage',
          label: 'Cover type',
          placeholder: 'Select cover type',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: PAGE_DATA.lifeStage
        }
      }

      const visaType = {
        question: 'Visa Type',

        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_type',
          label: 'Visa type',
          placeholder: 'Select visa type',
          dataValue: 'value',
          dataArr: [
            {
              name: 'Visitor',
              value: 'Visitor'
            },
            {
              name: 'Working',
              value: 'Working'
            },
            {
              name: 'Students',
              value: 'Student'
            }
          ]
        }
      }

      const visaSubtype = {
        question: 'Visa Subclass',

        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_subclass',
          label: 'Visa subclass',
          placeholder: 'Select visa subclass',
          dataInputDisplay: 'value',
          dataValue: 'value',
          dataArr: []
        }
      }

      const visaCode = {
        question: 'Enter visa subclass',

        component: 'AtomsInput',
        props: {
          name: 'other_subclass',
          placeholder: 'Input 3-4 digits Visa code',
          modelType: 'number',
          label: '',
          maxlength: '4'
        }
      }

      return {
        lifeStage,
        visaType,
        visaSubtype,
        visaCode
      }
    })()
  },

  step2: {
    header: {
      tag: 'free',
      title: '<strong>Get your quote in under 2 minutes!</strong>',
      component: 'div',
      desc: 'To help you find policies that best suit your needs, first we need to know a little bit about you and your circumstances.'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const countryOfCitizenship = {
        question: 'What\'s your main country of citizenship?',

        component: 'MoleculesCountry',
        props: {
          name: 'citizenship',
          label: 'Country',
          placeholder: 'Select your country of citizenship'
        }
      }

      const alreadyInAustralia = {
        question: 'Are you currently in Australia?',

        component: 'MoleculesSelection',
        props: {
          name: 'citizenship',
          type: 'radio',
          ticker: 'circle',
          options: [
            {
              label: 'Yes, I\'m currently in Australia',
              value: 'Yes'
            },
            {
              label: 'No, I\'m planning to move to Australia soon',
              value: 'No'
            }
          ]
        }
      }

      const stateInAustralia = {
        question: 'What is your state in Australia?',
        component: 'MoleculesStates',
        props: {}
      }

      const expectedEntryDate = {
        question: 'What is your expected date of entry into Australia?',

        component: 'AtomsDatepicker',
        props: {
          label: 'Date of arrival',
          placeholder: 'Enter your moving date (dd/mm/yyyy)',
          modelType: 'date',
          disableDatepicker: true
        }
      }

      const dateOfBirth = {
        question: 'What is your date of birth?',

        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Enter your date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true
        }
      }

      const coverLevel = {
        question: 'What level of cover would you like?',

        component: 'MoleculesSelection',
        props: {
          name: 'cover_level',
          type: 'radio',
          ticker: 'circle',
          options: [
            {
              name: 'basic',
              label: '<strong>Basic</strong>. I just want cheap basic cover to meet my visa requirements.',
              value: 'basic'
            },
            {
              name: 'medium',
              label: '<strong>Medium</strong>. I want a moderate level of cover that provides some additional benefits.',
              value: 'medium'
            },
            {
              name: 'top',
              label: '<strong>Top</strong>. I want the highest possible level of cover.',
              value: 'top'
            }
          ]
        }
      }

      return {
        countryOfCitizenship,
        alreadyInAustralia,
        stateInAustralia,
        expectedEntryDate,
        dateOfBirth,
        coverLevel
      }
    })()
  }
}

export const HEALTH_INSURANCE_VERTICAL_FORM_WIDGET_DATA = {
  title: 'I’d like <strong>health insurance</strong> cover for: ',
  redirect: '/health-insurance/quote/form/details/',
  formData: [
    {
      component: 'MoleculesSelectDropdown',
      componentClass: 'w-1/2',
      props: {
        name: 'life_stage',
        label: '',
        placeholder: 'Select',
        dataValue: 'value',
        dataArr: PAGE_DATA.lifeStage
      }
    },
    {
      component: 'AtomsInput',
      componentClass: 'w-1/2',
      props: {
        name: 'age',
        placeholder: 'Enter your age',
        modelType: 'number',
        label: '',
        maxlength: '3'
      }
    },
    {
      component: 'MoleculesSelectDropdown',
      componentClass: 'w-full',
      props: {
        name: 'cover_type',
        label: '',
        placeholder: 'Select cover level',
        dataListDisplay: 'label',
        dataInputDisplay: 'label',
        dataValue: 'value',
        dataArr: PAGE_DATA.coverType
      }
    },
    {
      component: 'MoleculesPostcode',
      componentClass: 'w-full',
      props: {
        name: 'postcode',
        label: ''
      }
    },
    {
      componentClass: 'w-full',
      component: 'MoleculesSelectDropdown',
      props: {
        name: 'health_fund',
        label: '',
        placeholder: 'Your current fund',
        dataListDisplay: 'label',
        dataInputDisplay: 'label',
        dataValue: 'value',
        dataSrc: 'https://asset.compareclub.com.au/json/fundlist.json'
      }
    }
  ]
}

export const FORM_WIDGET_DATA_V2 = {
  redirect: '/health-insurance/quote/form/details/',
  formData: [
    {
      component: 'MoleculesSelectDropdown',
      props: {
        name: 'life_stage',
        label: '',
        placeholder: 'Who is this cover for?',
        dataValue: 'value',
        dataListDisplay: 'label',
        dataInputDisplay: 'label',
        dataArr: PAGE_DATA.lifeStage
      }
    },
    {
      component: 'MoleculesPostcode',
      props: {
        name: 'postcode',
        placeholder: 'Enter your postcode',
        label: ''
      }
    }
  ]
}

export const OVHC_APPLICATION_FORM_ITEMS = {
  step1: {
    header: {
      title: `
        <strong class="font-extrabold"> Purchase Your Cover </strong>
      `,
      component: 'AtomsHeadline',
      desc: `
        <span class="text-base">Now you have selected your insurer, it is time to purchase your cover. But before you do, we need to know some information about you</span>
      `
    },
    buttons: {
      back: 'Back',
      main: 'Continue to dependant details'
    },
    form: (() => {
      const title = {
        question: 'Title',
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'title',
          label: 'Title',
          placeholder: 'Select your title',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: PAGE_DATA.title
        }
      }

      const gender = {
        question: 'Gender',
        component: 'MoleculesSelection',
        props: {
          name: 'gender',
          type: 'radio',
          ticker: 'circle',
          options: ['Male', 'Female'],
          cols: 2,
          mobileCols: 2
        }
      }

      const firstName = {
        question: 'First name',
        component: 'AtomsInput',
        props: {
          name: 'first_name',
          placeholder: 'Enter first name',
          label: '',
          theme: 'light'
        }
      }

      const lastName = {
        question: 'Last name',
        component: 'AtomsInput',
        props: {
          name: 'last_name',
          placeholder: 'Enter last name',
          label: '',
          theme: 'light'
        }
      }

      const passportNumber = {
        question: 'Passport Number',
        component: 'AtomsInput',
        props: {
          name: 'passport_number',
          placeholder: 'Enter Passport Number',
          label: '',
          modelType: 'text',
          theme: 'light'
        }
      }

      const email = {
        question: 'Email',
        component: 'AtomsInput',
        props: {
          name: 'email',
          placeholder: 'Enter your email',
          label: '',
          theme: 'light'
        },
        desc: 'We\'ll email you with a link to your saved quotes'
      }

      const australianPhoneNumber = {
        question: 'Phone Number',
        components: [
          'AtomsInput',
          'AtomsInput'
        ],
        name: 'australianPhone',
        props: [
          {
            name: 'area_code',
            placeholder: '(+61)',
            value: '04',
            theme: 'light',
            label: ''
          },
          {
            name: 'number',
            placeholder: 'Number',
            maxlength: '20',
            modelType: 'number',
            theme: 'light',
            label: ''
          }
        ]
      }

      const preferredContact = {
        question: 'What is your preferred method of contact?',
        component: 'MoleculesSelection',
        props: {
          name: 'preferred_contact',
          type: 'radio',
          ticker: 'circle',
          options: ['Email', 'Phone'],
          cols: 2,
          mobileCols: 2
        }
      }

      const hasAustralianMailingAddress = {
        question: 'Do you have an Australian mailing address?',
        component: 'MoleculesSelection',
        props: {
          name: 'has_australian_mailing_address',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          cols: 2,
          mobileCols: 2
        }
      }

      const australianAddress = {
        question: 'Where is the address?',
        component: 'MoleculesAddress',
        props: {
          name: 'australian_address',
          stickyAddress: true
        }
      }

      const overseasAddressLine1 = {
        question: 'Address line 1',
        component: 'AtomsInput',
        props: {
          theme: 'light',
          name: 'overseas_address_line_1',
          label: '',
          placeholder: 'Apartment, suite, unit, building, floor'
        }
      }

      const overseasAddressLine2 = {
        question: 'Address line 2',
        component: 'AtomsInput',
        props: {
          theme: 'light',
          name: 'overseas_address_line_2',
          label: '',
          placeholder: 'Street, Town'
        }
      }

      const overseasCity = {
        question: 'City',
        component: 'AtomsInput',
        props: {
          theme: 'light',
          name: 'overseas_city',
          label: '',
          placeholder: 'City'
        }
      }

      const overseasState = {
        question: 'State/Province',
        component: 'AtomsInput',
        props: {
          theme: 'light',
          name: 'overseas_state',
          label: '',
          placeholder: 'State/Province'
        }
      }

      const overseasPostcode = {
        question: 'Postcode',
        component: 'AtomsInput',
        props: {
          theme: 'light',
          name: 'overseas_city',
          label: '',
          modelType: 'number',
          placeholder: 'Postcode'
        }
      }

      const overseasCountry = {
        question: 'Country',
        component: 'MoleculesCountry',
        props: {
          name: 'overseas_country',
          label: 'Country',
          placeholder: 'Country'
        }
      }

      return {
        title,
        gender,
        firstName,
        lastName,
        passportNumber,
        email,
        australianPhoneNumber,
        preferredContact,
        hasAustralianMailingAddress,
        australianAddress,
        overseasAddressLine1,
        overseasAddressLine2,
        overseasCity,
        overseasState,
        overseasPostcode,
        overseasCountry
      }
    })()
  },
  step2: {
    header: {
      title: `
        <strong class="font-bold">Dependant Details</strong>
      `,
      component: 'AtomsHeadline',
      desc: `
        <span class="text-base">Are you coming to Australia alone? Or are there more people you would like to add to your policy? If you are coming to Australia with a partner or as a family, enter each person’s details below.</span>
      `
    },
    buttons: {
      back: 'Back to personal details',
      main: 'Continue to health details'
    },
    form: (() => {
      const partnerTitle = {
        partitionLabel: 'Partner',
        question: 'Title',
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'partner_title',
          label: 'Partner Title',
          placeholder: 'Select your partner\'s title',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: PAGE_DATA.title
        }
      }

      const partnerGender = {
        question: 'Gender',
        component: 'MoleculesSelection',
        props: {
          name: 'partner_gender',
          type: 'radio',
          ticker: 'circle',
          options: ['Male', 'Female'],
          cols: 2,
          mobileCols: 2
        }
      }

      const partnerFirstName = {
        question: 'First name',
        component: 'AtomsInput',
        props: {
          name: 'partner_first_name',
          placeholder: 'Your partner\'s first name',
          label: '',
          theme: 'light'
        }
      }

      const partnerLastName = {
        question: 'Last name',
        component: 'AtomsInput',
        props: {
          name: 'partner_last_name',
          placeholder: 'Your partner\'s last name',
          label: '',
          theme: 'light'
        }
      }

      const partnerBirthdate = {
        question: 'Date of Birth',
        component: 'MoleculesBirthdate',
        props: {
          label: 'Date of birth',
          placeholder: 'Enter your date of birth (dd/mm/yyyy)',
          validAge: PAGE_DATA.validAge,
          disableDatepicker: true
        }
      }

      const children = {
        component: 'OrganismsOHVCChildrenForm',
        props: {
          name: 'children',
          'children-data': []
        }
      }

      return {
        partnerTitle,
        partnerGender,
        partnerFirstName,
        partnerLastName,
        partnerBirthdate,
        children
      }
    })()
  },

  step3: {
    header: {
      title: `
        <strong class="font-extrabold"> Health Details </strong>
      `,
      component: 'AtomsHeadline',
      desc: `
        <span class="text-base">We need to know your health details to make sure you have the best Australian health cover to suit your needs.</span>
      `
    },
    buttons: {
      back: 'Back to dependant details',
      main: 'Continue to visa details'
    },

    form: (() => {
      const existingHealthInsurance = {
        question: 'Existing health insurance',
        desc: 'Do you currently have Overseas Visitor\'s Health insurance in Australia?',
        component: 'MoleculesSelection',
        props: {
          name: 'existing_health_insurance',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          cols: 2
        }
      }

      const currentHealthFund = {
        question: 'Health fund',
        component: 'MoleculesSelectDropdown',
        componentDesc: '<p class="text-xs mt-2">Leave it to us to contact your previous health fund and cancel your existing policy. Any waiting periods you’ve already served will also be recognised.</p>',
        desc: 'Select your current Overseas Visitors helath insurer Fund',
        props: {
          name: 'health_fund',
          label: '',
          placeholder: 'Select a health fund',
          dataListDisplay: 'label',
          dataInputDisplay: 'label',
          dataValue: 'label',
          dataArr: ['Medibank', 'Nib', 'Frank', 'CBHS International Care', 'Allianz Care', 'Australian Unity', 'BUPA', 'Other']
        }
      }

      const currentMembershipNumber = {
        question: 'Membership Number',
        components: ['AtomsInput', 'MoleculesSelection'],
        props: [
          {
            name: 'current_membership_number',
            placeholder: 'Your fund membership number',
            label: '',
            theme: 'light'
          },
          {
            name: 'allow_fund_contact',
            options: [],
            cols: 1,
            'no-box': true,
            size: 'xs',
            theme: 'tertiary',
            'mobile-cols': 1,
            'error-tooltip': false
          }
        ]
      }

      const preExistingConditions = {
        question: 'Pre-existing health conditions',
        component: 'MoleculesSelection',
        props: {
          name: 'pre_existing_conditions',
          type: 'radio',
          ticker: 'circle',
          options: ['Yes', 'No'],
          cols: 2
        }
      }

      return {
        existingHealthInsurance,
        currentHealthFund,
        currentMembershipNumber,
        preExistingConditions
      }
    })()
  },

  step4: {
    header: {
      title: `
        <strong class="font-extrabold">Visa Details</strong>
      `,
      component: 'AtomsHeadline',
      desc: `
        <span class="text-base">And finally, we need your visa details to pass on to your new Australian health insurer.</span>
      `
    },
    buttons: {
      back: 'Back to health details',
      main: 'Continue to review'
    },

    form: (() => {
      const visaSubType = {
        question: 'Visa Subtype',
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_type',
          label: 'Visa type',
          placeholder: 'Select visa type',
          dataValue: 'value',
          dataArr: [
            {
              name: 'Visitor',
              value: 'Visitor'
            },
            {
              name: 'Working',
              value: 'Working'
            },
            {
              name: 'Students',
              value: 'Student'
            }
          ]
        }
      }

      const visaSubclass = {
        question: 'Visa Subclass',

        component: 'MoleculesSelectDropdown',
        props: {
          name: 'visa_subclass',
          label: 'Visa subclass',
          placeholder: 'Select visa subclass',
          dataInputDisplay: 'value',
          dataValue: 'value',
          dataArr: []
        }
      }

      const visaGrantDate = {
        question: 'Your Visa grant date',
        component: 'AtomsDatepicker',
        props: {
          label: 'Visa Grant Date',
          placeholder: 'dd/mm/yyyy',
          modelType: 'date',
          disableDatepicker: true
        }
      }

      const coverStartDate = {
        question: 'Estimated Cover Start Date',
        component: 'AtomsDatepicker',
        props: {
          label: 'cover start date',
          placeholder: 'dd/mm/yyyy',
          modelType: 'date',
          disableDatepicker: true
        }
      }

      const sponsorName = {
        question: 'Sponsor\'s name',
        component: 'AtomsInput',
        props: {
          name: 'sponsor_full_name',
          placeholder: 'Enter sponsor\'s name',
          label: '',
          theme: 'light'
        }
      }

      const sponsorEmail = {
        question: 'Sponsor\'s email',
        component: 'AtomsInput',
        props: {
          name: 'sponsor_email',
          placeholder: 'Enter sponsor\'s email',
          label: '',
          theme: 'light'
        }
      }

      const sponsorPhone = {
        question: 'Sponsor\'s phone',
        desc: `Australian landline: include your area code e.g.
            (02) 0000 0000 Or Australian mobile: e.g. 0400 000 000`,
        component: 'AtomsInput',
        props: {
          name: 'sponsor_phone',
          placeholder: 'Your sponsor\'s phone number',
          modelType: 'number',
          label: '',
          maxlength: '10'
        }
      }

      return {
        visaSubType,
        visaSubclass,
        visaGrantDate,
        coverStartDate,
        sponsorName,
        sponsorEmail,
        sponsorPhone
      }
    })()
  },

  step5: {
    header: {
      title: `
        <strong class="font-extrabold">Payment Details</strong>
      `,
      component: 'AtomsHeadline'
    },
    buttons: {
      back: 'Back to visa details',
      main: 'Submit my application'
    },
    form: (() => {
      const paymentFrequency = {
        question: 'How often would you like to pay?',
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'payment_frequency',
          label: 'Payment frequency',
          dataValue: 'value',
          dataInputDisplay: 'label',
          dataListDisplay: 'label',
          dataArr: [
            {
              label: 'Monthly',
              value: 'Monthly'
            },
            {
              label: 'Annually',
              value: 'Yearly'
            }
          ]
        }
      }

      const paymentType = {
        question: 'How would you like to pay for your cover?',
        component: 'MoleculesSelectDropdown',
        props: {
          name: 'payment_type',
          label: 'Payment Type',
          dataValue: 'value',
          dataArr: ['Credit Card', 'Bank Account']
        }
      }

      const cardholderName = {
        question: 'Cardholder name',
        component: 'AtomsInput',
        props: {
          name: 'cardholder_name',
          placeholder: 'Cardholder name',
          label: '',
          theme: 'light'
        }
      }

      const cardNumber = {
        question: 'Card number',
        component: 'MoleculesCreditCard',
        props: {
          name: 'card number',
          placeholder: 'Card number',
          theme: 'light'
        }
      }

      const cardCvv = {
        question: 'Card Cvv',
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'card cvv',
          placeholder: 'Card cvv',
          theme: 'light',
          label: 'Card cvv',
          type: 'number',
          maxlength: '4'
        }
      }

      const cardExpDate = {
        question: 'Expiration date',
        component: 'AtomsDatepicker',
        props: {
          name: 'card expiration date',
          placeholder: 'mm / yy',
          format: 'MM/YY',
          valueType: 'MM/YY',
          dateFormat: 'MM/YY',
          theme: 'light',
          label: '',
          size: 'default',
          modelType: 'date',
          disableDatepicker: true
        }
      }

      const bankName = {
        question: 'Bank Name',
        component: 'AtomsInput',
        props: {
          name: 'Bank Name',
          placeholder: 'Bank Name',
          theme: 'light',
          label: 'Bank Name'
        }
      }

      const bankAccountHolderName = {
        question: 'Account Name',
        component: 'AtomsInput',
        props: {
          name: 'Account Name',
          placeholder: 'Account Name',
          theme: 'light',
          label: 'Account Name'
        }
      }
      const bankAccountNumber = {
        question: 'Bank Account Number',
        component: 'AtomsInput',
        props: {
          name: 'Bank Account Number',
          placeholder: 'Bank Account Number',
          theme: 'light',
          label: 'Bank Account Number',
          type: 'number',
          maxlength: '10'
        }
      }

      const bankBsb = {
        question: 'BSB Number',
        component: 'AtomsInput',
        componentClass: 'w-1/2',
        props: {
          name: 'bank bsb',
          placeholder: 'BSB Number',
          theme: 'light',
          label: 'Bank Bsb',
          type: 'number',
          maxlength: '10'
        }
      }

      return {
        paymentFrequency,
        paymentType,
        cardholderName,
        cardNumber,
        cardCvv,
        cardExpDate,
        bankName,
        bankAccountHolderName,
        bankAccountNumber,
        bankBsb
      }
    })()
  }
}

export const OVHC_CHILDREN_APPLICATION_CONTENT = {
  form: (() => {
    const childTitle = {
      question: 'Title',
      component: 'MoleculesSelectDropdown',
      props: {
        label: 'Child Title',
        placeholder: 'Select your child\'s title',
        dataValue: 'value',
        dataInputDisplay: 'label',
        dataListDisplay: 'label',
        dataArr: PAGE_DATA.title
      }
    }

    const childGender = {
      question: 'Gender',
      component: 'MoleculesSelection',
      props: {
        name: 'child_gender',
        type: 'radio',
        ticker: 'circle',
        options: ['Male', 'Female'],
        cols: 2,
        mobileCols: 2
      }
    }

    const childFirstName = {
      question: 'First name',
      component: 'AtomsInput',
      props: {
        name: 'child_first_name',
        placeholder: 'Your child\'s first name',
        label: '',
        theme: 'light'
      }
    }

    const childLastName = {
      question: 'Last name',
      component: 'AtomsInput',
      props: {
        name: 'child_last_name',
        placeholder: 'Your child\'s last name',
        label: '',
        theme: 'light'
      }
    }

    const childBirthDate = {
      question: 'Date of Birth',
      component: 'MoleculesBirthdate',
      props: {
        label: 'Date of birth',
        placeholder: 'Enter your child\'s date of birth (dd/mm/yyyy)',
        validAge: [1, 120],
        disableDatepicker: true
      }
    }

    return {
      childTitle,
      childGender,
      childFirstName,
      childLastName,
      childBirthDate
    }
  })()
}
